import { repeat } from 'lodash/fp';
import React, { Fragment } from 'react';

const LEADING_SPACES_REGEX = /^\s+/gm;
const LEADING_TABS_REGEX = /^\t+/gm;
const HTML_SPACE = '\u00A0';

/**
 * Takes a string and preserves its whitespace formatting
 * @param  {string} children - children should be a string
 * @param  {number} tabSize=2 - size of the tab character in spaces
 * @param  {bool}   preferParagraphs - use <p> tags instead of <br>'s
 */
const PreserveFormatting = ({ children, tabSize = 2, preferParagraphs }) => {
  if (children === null || children === undefined) return null;
  if (typeof children !== 'string') {
    if (process.env.NODE_ENV === 'development') {
      console.warn('children is not a string');
    }
    return null;
  }

  const formattedChildren = children
    .trim()
    .replace(LEADING_TABS_REGEX, tabs =>
      tabs.replace(/./g, repeat(tabSize, HTML_SPACE)),
    )
    .replace(LEADING_SPACES_REGEX, spaces => spaces.replace(/./g, HTML_SPACE));

  const formattedLines = formattedChildren.split('\n');
  const lineCount = formattedLines.length - 1;
  const Wrapper = preferParagraphs ? 'p' : Fragment;
  const newlineChildren = formattedLines.map((line, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <Wrapper key={i}>
      {line}
      {!preferParagraphs && i !== lineCount && <br />}
    </Wrapper>
  ));

  return <>{newlineChildren}</>;
};

export default PreserveFormatting;
